import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function BankBonusDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [bankName, setBankName] = useState("");
  const [acNumber, setAcNumber] = useState("");
  const [holderName, setHolderName] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [branchName, setBranchName] = useState("");

  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/adminBankDetailsHistory",
        {
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          btcaddress: `${item?.btcaddress} `,
          acholdername: `${item?.acholdername}`,
          Bank_Name: `${item?.Bank_Name}`,
          ifsc: item?.ifsc,
          Branch: `${item?.Branch}`,
          dd: `${item?.dd}`,
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      let responceRight = await API?.post(
        "/updateAdminBankDetails",
        {
          loginid: userId,
          accountnumber: acNumber,
          bankname: bankName,
          id: "",
          accountholdername: holderName,
          ifsc: ifsc,
          branch: branchName,
          eby: "Admin",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data);
    //   console.log("response", responceRight?.data?.data[0][0]);
    //   responceRight = responceRight?.data?.data;
        if (responceRight?.data?.data == "Success") {
          toast.success("Updated Successfully !!");
          referral_API();
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          toast.error(responceRight?.data?.data);
        }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Account Number", accessor: "btcaddress" },
      { Header: "Holder Name", accessor: "acholdername" },
      { Header: "Bank Name", accessor: "Bank_Name" },
      { Header: "IFSC", accessor: "ifsc" },
      { Header: "Branch Name", accessor: "Branch" },
      { Header: "Date ", accessor: "dd" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title"> Update Bank Details</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}>
                    <div className="col-md-12">
                      <>
                        {" "}
                        <div className="row mb-5">
                          <form>
                            <div className="col-sm-4 p-2">
                              <input
                                className="form-control in-ip-1"
                                id="Acname"
                                onChange={(e) => setHolderName(e.target.value)}
                                name="Acname"
                                placeholder="Enter Account Holder Name"
                                type="text"
                                value={holderName}
                              />
                            </div>
                            <div className="col-sm-4 p-2">
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                onChange={(e) => setAcNumber(e.target.value)}
                                name="upiid"
                                placeholder="Enter Account Number"
                                type="text"
                                value={acNumber}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-4 p-2">
                              <input
                                className="form-control in-ip-1"
                                id="ifsc"
                                onChange={(e) => setIfsc(e.target.value)}
                                name="ifsc"
                                placeholder="Enter IFSC Code"
                                type="text"
                                value={ifsc}
                              />
                            </div>
                            <div className="col-sm-4 p-2">
                              <input
                                className="form-control in-ip-1"
                                id="imglink"
                                onChange={(e) => setBankName(e.target.value)}
                                name="imglink"
                                placeholder="Enter Bank Name"
                                type="text"
                                value={bankName}
                              />
                            </div>

                            <div className="col-sm-4 p-2">
                              <input
                                className="form-control in-ip-1"
                                id="Bname"
                                onChange={(e) => setBranchName(e.target.value)}
                                name="Bname"
                                placeholder="Enter Branch Name"
                                type="text"
                                value={branchName}
                              />
                            </div>

                            <div className="col-sm-1 p-2">
                              <input
                                type="button"
                                id="btnsearch"
                                onClick={() => OnhandleSubmit_API()}
                                className="btn btn-sm btn-primary"
                                value="Update"
                              />
                            </div>
                          </form>
                        </div>
                      </>
                      <div className="row panel panel-primary">
                        <div className="panel-heading">
                          <h4 className="panel-title"> Bank Details</h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}>
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
